import { useIntl } from 'react-intl';
import { SettingsBreadcrumbs } from '../../../containers/Settings/SettingsBreadcrumbs';
import { RulePage } from '../../rules/rule-detail/RulePage';
import { ruleManagerPath } from '../routes';
import { RuleManagerTabs } from '../RuleManagerTabs';

export const CreateRulePage = () => {
  const intl = useIntl();
  const parentPath = ruleManagerPath();

  return (
    <RulePage
      parentPath={parentPath}
      renderTabs={() => (
        <RuleManagerTabs
          linkedQueuesDisabled
          value="detail"
          parentPath={`${parentPath}/new`}
          queuesLength={0}
        />
      )}
      renderBreadcrumbs={breadcrumbs => (
        <SettingsBreadcrumbs
          breadcrumbs={[
            {
              label: intl.formatMessage({
                id: 'features.ruleManager.list.title',
              }),
              to: parentPath,
            },
            ...breadcrumbs,
          ]}
        />
      )}
    />
  );
};
